// src/components/common/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaNewspaper, FaPodcast, FaCode, FaGlobe, FaEnvelope, FaPhone} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
      <div>
        <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
        <ul className="space-y-2">
          <li><Link to="/about" className="hover:text-blue-300">About Us</Link></li>
          <li><Link to="/contact" className="hover:text-blue-300">Contact</Link></li>
          <li><Link to="/faq" className="hover:text-blue-300">FAQ</Link></li>
          <li><Link to="/privacy" className="hover:text-blue-300">Privacy Policy</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="text-xl font-semibold mb-4">Resources</h3>
        <ul className="space-y-2">
          <li><Link to="/events" className="hover:text-blue-300">Events Calendar</Link></li>
          <li><Link to="/jobs" className="hover:text-blue-300">Job Board</Link></li>
          <li><Link to="/mentorship" className="hover:text-blue-300">Mentorship Program</Link></li>
          <li><Link to="/donate" className="hover:text-blue-300">Make a Donation</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="text-xl font-semibold mb-4">Stay Connected</h3>
        <ul className="space-y-2">
          <li><a href="#" className="hover:text-blue-300 flex items-center"><FaLinkedin className="mr-2" /> LinkedIn</a></li>
          <li><a href="#" className="hover:text-blue-300 flex items-center"><FaNewspaper className="mr-2" /> Newsletter</a></li>
          <li><a href="#" className="hover:text-blue-300 flex items-center"><FaPodcast className="mr-2" /> Podcast</a></li>
          <li><a href="#" className="hover:text-blue-300 flex items-center"><FaPodcast className="mr-2" /> Podcast</a></li>
          <li><a href="#" className="hover:text-blue-300 flex items-center"><FaCode className="mr-2" /> Tech Blog</a></li>
        </ul>
      </div>
      <div>
        <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
        <p className="flex items-center mb-2"><FaGlobe className="mr-2" /> 123 University Ave, City, State 12345</p>
        <p className="flex items-center mb-2"><FaEnvelope className="mr-2" /> alumni@university.edu</p>
        <p className="flex items-center"><FaPhone className="mr-2" /> (123) 456-7890</p>
      </div>
    </div>
    <div className="mt-8 pt-8 border-t border-gray-700 text-center">
      <p>&copy; 2024 Saarthi. All rights reserved.</p>
    </div>
  </footer>
  );
};

export default Footer;